import { render, staticRenderFns } from "./CurrentEarnings.vue?vue&type=template&id=6bf61aec&scoped=true"
import script from "./CurrentEarnings.vue?vue&type=script&lang=js"
export * from "./CurrentEarnings.vue?vue&type=script&lang=js"
import style0 from "./CurrentEarnings.vue?vue&type=style&index=0&id=6bf61aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf61aec",
  null
  
)

export default component.exports